import styled from 'styled-components';

const CardOverlay = styled.div`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.colors.corporateWhite};
  opacity: 0.7;
`;

export default CardOverlay;
